class FreeGiftUpsell extends HTMLElement {
  constructor() {
    super();
    this.radioButtons = this.querySelectorAll('input[type="radio"]');
    this.cards = this.querySelectorAll('.free-gift-card');
    this.handleChange = this.handleChange.bind(this);
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.radioButtons.forEach(radio => radio.addEventListener('change', this.handleChange));
    this.updateSelectedState();
    this.setupColorSwatches();
  }

  disconnectedCallback() {
    this.radioButtons.forEach(radio => radio.removeEventListener('change', this.handleChange));
  }

  setLoading(isLoading) {
    this.toggleAttribute('loading', isLoading);
    if (this.cartDrawer) {
      this.cartDrawer.toggleAttribute('loading', isLoading);
    }
  }

  updateSelectedState() {
    this.cards.forEach(card => {
      const radio = card.querySelector('input[type="radio"]');
      if (radio.checked) {
        card.classList.add('is-selected');
      } else {
        card.classList.remove('is-selected');
      }
    });
  }

  // Set up color swatch functionality
  setupColorSwatches() {
    const colorSwatches = this.querySelectorAll('.free-gift-card__color-swatch');
    
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (e.currentTarget.classList.contains('is-disabled')) return;
        
        const productId = e.currentTarget.getAttribute('data-product-id');
        const variantId = e.currentTarget.getAttribute('data-variant-id');
        const variantImage = e.currentTarget.getAttribute('data-variant-image');
        const selector = e.currentTarget.closest('.free-gift-card__color-selector');
        const card = e.currentTarget.closest('.free-gift-card');
        
        // Update swatch selection
        selector.querySelectorAll('.free-gift-card__color-swatch').forEach(s => {
          s.classList.remove('is-selected');
          const checkmark = s.querySelector('.free-gift-card__checkmark');
          if (checkmark) checkmark.remove();
        });
        
        e.currentTarget.classList.add('is-selected');
        if (!e.currentTarget.querySelector('.free-gift-card__checkmark')) {
          const checkmark = document.createElement('span');
          checkmark.className = 'free-gift-card__checkmark';
          checkmark.innerHTML = `
            <svg width="8" height="8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12l5 5 9-9" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          e.currentTarget.appendChild(checkmark);
        }
        
        // Update variant ID in card and radio button
        if (card) {
          card.setAttribute('data-variant-id', variantId);
          const radio = card.querySelector('input[type="radio"]');
          if (radio) {
            radio.value = variantId;
          }
        }
        
        // Update product image
        const productImage = card.querySelector(`[data-product-featured-image="${productId}"]`);
        if (productImage && variantImage) {
          productImage.src = variantImage;
        }
        
        // Automatically select this card
        const radio = card.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.updateSelectedState();
          this.handleChange({ target: radio });
        }
      });
    });
  }

  async handleChange(event) {
    const selectedVariantId = event.target.value;
    this.updateSelectedState();
    this.setLoading(true);

    try {
      const currentCart = await fetch('/cart.js').then(res => res.json());
      const updates = {};
      let isSelectedGiftInCart = false;

      currentCart.items.forEach(item => {
        if (item.properties && item.properties._is_free_gift) {
          if (item.variant_id.toString() !== selectedVariantId) {
            updates[item.key] = 0;
          } else {
            isSelectedGiftInCart = true;
          }
        }
      });

      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      if (!isSelectedGiftInCart) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: selectedVariantId,
              quantity: 1,
              properties: {
                _is_free_gift: true
              }
            }]
          })
        });
      }
      
      if (this.cartDrawer) {
        this.cartDrawer.forceUpdate();
      }

    } catch (error) {
      console.error('Failed to update cart with free gift:', error);
    } finally {
      this.setLoading(false);
    }
  }
}

if (!customElements.get('free-gift-upsell')) {
  customElements.define('free-gift-upsell', FreeGiftUpsell);
} 